import { useEffect } from 'react';
import StorageService from '@/shared/lib/utils/storage';
import { STORAGE_KEYS } from '@/shared/constants/common';
const EXPIRATION_DAYS = 7;
const MS_IN_A_DAY = 24 * 60 * 60 * 1000;
export const useTokenExpiration = () => {
    useEffect(() => {
        const token = StorageService.get(STORAGE_KEYS.accessToken, false);
        const timestamp = StorageService.get(STORAGE_KEYS.accessTokenTimestamp, false);
        if (token && timestamp) {
            const now = Date.now();
            const age = now - Number(timestamp);
            if (age > EXPIRATION_DAYS * MS_IN_A_DAY) {
                StorageService.remove(STORAGE_KEYS.accessToken);
                StorageService.remove(STORAGE_KEYS.accessTokenTimestamp);
            }
        }
    }, []);
};
